// extracted by mini-css-extract-plugin
export var wordContainer = "_jv-0";